export default {"src":"/_next/static/media/logo.455cfadb.svg","height":420,"width":512,"blurWidth":0,"blurHeight":0};